/**
 * Format a timestamp as a short relative string (e.g. `2h ago`).
 *
 * Buckets:
 * - null/undefined → `Never`
 * - `< 60s` → `Just now`
 * - `< 60m` → `{n}m ago`
 * - `< 24h` → `{n}h ago`
 * - else → `{n}d ago`
 *
 * Plain `Date` math; no `date-fns` dependency.
 */
export function formatRelativeTime(
  value: string | Date | null | undefined,
  now: Date = new Date(),
): string {
  if (value === null || value === undefined) return "Never";

  const then = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(then.getTime())) return "Never";

  const diffMs = now.getTime() - then.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 60) return "Just now";

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay}d ago`;
}
